import { parseRes } from './utils/parseRes';
import { parseXLSX } from './utils/parseXLSX';

export function oanParseHitec(xlsx, res) {
  const variables = parseXLSX(xlsx);
  const meta = parseRes(res);
  return { variables, meta };
}
